import React, { useState, useEffect } from "react";
import ApiClient from "../utils/ApiClient";
import ReceiveInventoryTabs from "../components/ReceiveInventory/ReceiveInventoryTabs";

const ReceiveInventory = () => {
    const [gtinDigits, setGtinDigits] = useState("12");
    const [poNumbers, setPoNumbers] = useState([]);
    const [poSelected, setPoSelected] = useState("");
    const [dataTab1, setDataTab1] = useState([]);
    const [dataTab2, setDataTab2] = useState([]);
    const [recordStatus, setRecordStatus] = useState(true);
    const [message, setMessage] = useState(null);
    const [scannedData, setScannedData] = useState([]);
    const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());
    const [activeTab, setActiveTab] = useState("POData");

    useEffect(() => {
        setScannedData([]);
    }, [poSelected]);

    useEffect(() => {
        ApiClient.post("/api/receiveinventory/getponumbers")
            .then((response) => {
                if (response.data && Array.isArray(response.data)) {
                    setPoNumbers(response.data);
                } else {
                    console.error("Invalid response structure", response);
                }
            })
            .catch((error) => {
                console.error("Failed to fetch PO numbers", error);
            });
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date().toLocaleTimeString());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const handlePOChange = (e) => {
        const newValue = e.target.value;
        setScannedData([]);
        setPoSelected(newValue);
        setDataTab1([]);
        setDataTab2([]);
    };

    return (
        <div className="container mx-auto p-4">
            <header className="mb-4">
                <h2 className="text-2xl font-bold">Receive Shipment</h2>
            </header>
            <div className="flex justify-between items-center mb-4">
                <div className="flex-1">
                    <label>Select Purchase Order</label>
                    <select
                        className="border border-gray-300 rounded px-3 py-2 focus:ring focus:outline-none"
                        value={poSelected}
                        onChange={handlePOChange}
                    >
                        <option value="" disabled>
                            Please Select a PO
                        </option>
                        {poNumbers.map((option, index) => (
                            <option key={index} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="text-sm font-medium text-gray-500">
                    Current Time: <span className="font-bold text-gray-800">{currentTime}</span>
                </div>
            </div>
            <ReceiveInventoryTabs
                key={poSelected}
                poSelected={poSelected}
                scannedData={scannedData}
                setScannedData={setScannedData}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />
        </div>
    );
};

export default ReceiveInventory;